import {TooltipDomInjector} from '../tooltip-dom-injector';
import {Observable} from 'rxjs';
import {GlossaryRecord} from '../../glossary/model/glossary-record.model';

export class TooltipNode {
    domInjector: TooltipDomInjector;
    content: string = null;
    initializer: Observable<GlossaryRecord>;

    constructor(
        public id: string
    ) {
    }
}